module.exports = __webpack_public_path__ + "static/media/HB4.638eea77.png";